import { ComponentStylesWithFns } from '../../../theme/styles.helpers';

export const BookingDetailsStyles: ComponentStylesWithFns = {
  root: {
    display: 'flex',
    height: '100%',
    width: '100%',
  },
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    overflowX: 'hidden',
    backgroundColor: 'primary.main',
    marginLeft: 5,
    borderRadius: '10px',
  },
  header: {
    display: 'flex',
    padding: 3,
    backgroundColor: 'white',
    borderBottom: '0.5px solid',
    borderColor: 'grey.200',
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerTitle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  bookingDetails: {
    display: 'flex',

    justifyContent: 'space-between',
    padding: '20px 30px',
    marginBottom: '20px',
    flexGrow: 1,
    maxHeight: 'calc(100% - 60px)',
    overflowY: 'auto',
    scrollbarColor: 'black #f6ebe4',
    scrollbarWidth: 'thin',
  },
  leftContainer: {
    flex: 1,
    overflow: 'auto',
    height: '100%',
    padding: 4,
  },
  rightContainer: {
    width: '50%',
    padding: 4,
    backgroundColor: 'white',
    borderLeft: '0.5px solid',
    borderColor: 'grey.200',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    justifyContent: 'space-between',
    overflow: 'auto',
  },
  divider: {
    marginY: 2,
  },
};
